import { PRODUCT } from "@/constants";

const renewalSubColorSts = "text-dark-text-title";
const renewalSubColorAvn = "text-text-functional-subtle";

const classNames = {
  avanti: {
    ESSENTIALS: {
      topSectionclassName: "essentials",
      headerClassName: "text-text-title",
      headerDetaisClassNames: {
        mainTextClassName: "text-text-body font-header-font",
        subTextClassName: "text-text-functional-subtle font-body-font",
        renewalSubColor: renewalSubColorAvn,
      },
    },
    CLASSIC: {
      topSectionclassName: "classic",
      headerClassName: "text-text-title",
      headerDetaisClassNames: {
        mainTextClassName: "text-text-body font-header-font",
        subTextClassName: "text-text-functional-subtle font-body-font",
        renewalSubColor: renewalSubColorAvn,
      },
    },
    DELUXE: {
      topSectionclassName: "deluxe",
      headerClassName: "text-text-title",
      headerDetaisClassNames: {
        mainTextClassName: "text-text-body font-header-font",
        subTextClassName: "text-text-functional-subtle font-body-font",
        renewalSubColor: renewalSubColorAvn,
      },
    },
  },
  staysure: {
    BASIC: {
      topSectionclassName: "basic",
      headerClassName: "text-dark-text-title",
      headerDetaisClassNames: {
        mainTextClassName: "text-dark-text-title",
        subTextClassName: "text-dark-text-functional-subtle",
        renewalSubColor: renewalSubColorSts,
      },
    },
    COMPREHENSIVE: {
      topSectionclassName: "comprehensive",
      headerClassName: "text-dark-text-title",
      headerDetaisClassNames: {
        mainTextClassName: "text-dark-text-title",
        subTextClassName: "text-dark-text-functional-subtle",
        renewalSubColor: renewalSubColorSts,
      },
    },
    SIGNATURE: {
      topSectionclassName: "signature",
      headerClassName: "text-dark-interactive-primary-hovered",
      headerDetaisClassNames: {
        mainTextClassName: "text-dark-text-title",
        subTextClassName: "text-dark-text-functional-subtle",
        renewalSubColor: renewalSubColorSts,
      },
    },
  },
};

const brand: "staysure" | "avanti" =
  (PRODUCT as "staysure" | "avanti") ?? "staysure";

const headerClassNames = classNames[brand];

export default headerClassNames;
